/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 08:51:35
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-24 11:02:14
 * @Custom by Shark
 */
import CheckBoxControl from '../checkbox';

/**
 * CheckboxCBntrol
 */
export default class CheckBoxesControl {
  $input: JQuery;
  options: any;
  $wrap: JQuery;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    const _this = this;
    this.$input = $input;
    this.options = options;
    this.$wrap = $input.closest('.checkbox-group');
    if (!this.$wrap.length) {
      return;
    }

    const opts = {
      /**
       * onChange
       * @param data .
       */
      onChange: (data: any) => {
        const name = data.name;
        const value: any = [];
        _this.$wrap.find('input[name=' + name + ']:checked').each(function () {
          value.push(jQuery(this).val());
        });
        //value of checkbox is array
        const result = {
          name: name,
          value: value,
        };
        if (_this.options && _this.options.onChange) {
          _this.options.onChange(result);
        }
      },
    };

    $input.each(function () {
      new CheckBoxControl(jQuery(this), opts);
    });
  }

  /**
   * Set value to select
   * @param vals ..
   * @returns void
   */
  setValue(vals: string[] | number[]): void {
    this.$input.prop('checked', false);
    for (let i = 0; i < vals.length; i++) {
      this.$wrap.find('input[value=' + vals[i] + ']').prop('checked', true);
    }
  }
}
